import p from "@babel/runtime/helpers/esm/objectSpread2";
import w from "@babel/runtime/helpers/esm/classCallCheck";
import k from "@babel/runtime/helpers/esm/createClass";
import P from "@babel/runtime/helpers/esm/inherits";
import A from "@babel/runtime/helpers/esm/createSuper";
import s from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as I } from "@semcore/utils/lib/core/index";
import L, { sstyled as h, assignProps as m, Component as C } from "@semcore/core";
import t from "react";
import { Box as v, InvalidStateBox as E } from "@semcore/flex-box";
import F from "@semcore/neighbor-location";
import j from "@semcore/utils/lib/enhances/keyboardFocusEnhance";
import N from "@semcore/utils/lib/addonTextChildren";
import R from "@semcore/utils/lib/logger";
import $ from "@semcore/utils/lib/enhances/animatedSizeEnhance";
import { cssVariableEnhance as D } from "@semcore/utils/lib/useCssVariable";
var O = (
  /*__reshadow_css_start__*/
  (I.insert(
    /*__inner_css_start__*/
    ".___SBaseTrigger_1rf65_gg_{display:inline-block;align-items:center;justify-content:center;line-height:normal;position:relative;touch-action:manipulation;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;user-select:none;box-sizing:border-box;padding:0;margin:0;box-shadow:none;-webkit-text-decoration:none;text-decoration:none;-webkit-tap-highlight-color:transparent;overflow:visible;outline:0;text-align:center;vertical-align:middle;font-family:inherit;cursor:pointer;background:var(--intergalactic-bg-primary-neutral, #ffffff);font-weight:var(--intergalactic-regular, 400);border:1px solid var(--intergalactic-border-primary, #c4c7cf);color:var(--intergalactic-text-primary, #191b23)}.___SBaseTrigger_1rf65_gg_::-moz-focus-inner{border:0;padding:0}.___SBaseTrigger_1rf65_gg_:active,.___SBaseTrigger_1rf65_gg_:focus{outline:0;-webkit-text-decoration:none;text-decoration:none}@media (hover:hover){.___SBaseTrigger_1rf65_gg_:hover{outline:0;-webkit-text-decoration:none;text-decoration:none}}.___SBaseTrigger_1rf65_gg_.__keyboardFocused_1rf65_gg_{border:1px solid var(--intergalactic-border-info-active, #006dca);box-shadow:var(--intergalactic-keyboard-focus, 0px 0px 0px 3px rgba(0, 143, 248, 0.5));z-index:1}@media (hover:hover){.___SBaseTrigger_1rf65_gg_:hover{background-color:var(--intergalactic-bg-primary-neutral-hover, #f4f5f9)}}.___SBaseTrigger_1rf65_gg_.__active_1rf65_gg_,.___SBaseTrigger_1rf65_gg_:active{border-color:var(--intergalactic-border-info-active, #006dca);background-color:var(--intergalactic-bg-primary-neutral, #ffffff)}.___SBaseTrigger_1rf65_gg_.__disabled_1rf65_gg_{opacity:var(--intergalactic-disabled-opacity, 0.3);cursor:default;pointer-events:none}.___SInner_1rf65_gg_{display:inline-flex;align-items:center;justify-content:center;height:100%;width:100%}.___SText_1rf65_gg_{display:inline;padding:1px 0;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;line-height:var(--intergalactic-lh-200, 142%);flex-grow:1;text-align:left}.___SAddon_1rf65_gg_{display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;pointer-events:none}.___SBaseAddon_1rf65_gg_{width:12px;height:12px}.___SBaseTrigger_1rf65_gg_._size_m_1rf65_gg_{min-width:26px;height:28px;border-radius:var(--intergalactic-control-rounded, 6px);padding:0 var(--intergalactic-spacing-2x, 8px);font-size:var(--intergalactic-fs-200, 14px)}.___SBaseTrigger_1rf65_gg_._size_m_1rf65_gg_ .___SAddon_1rf65_gg_:not(:only-child):first-child{margin-right:var(--intergalactic-spacing-2x, 8px)}.___SBaseTrigger_1rf65_gg_._size_m_1rf65_gg_ .___SAddon_1rf65_gg_:not(:only-child):last-child{margin-left:var(--intergalactic-spacing-2x, 8px)}.___SBaseTrigger_1rf65_gg_._size_l_1rf65_gg_ .___SAddon_1rf65_gg_:only-child,.___SBaseTrigger_1rf65_gg_._size_m_1rf65_gg_ .___SAddon_1rf65_gg_:only-child{margin-left:calc(-1*var(--intergalactic-spacing-1x, 4px));margin-right:calc(-1*var(--intergalactic-spacing-1x, 4px))}.___SBaseTrigger_1rf65_gg_._size_l_1rf65_gg_{min-width:32px;height:40px;border-radius:var(--intergalactic-control-rounded, 6px);padding:0 var(--intergalactic-spacing-3x, 12px);font-size:var(--intergalactic-fs-300, 16px)}.___SBaseTrigger_1rf65_gg_._size_l_1rf65_gg_ .___SAddon_1rf65_gg_:not(:only-child):first-child{margin-right:var(--intergalactic-spacing-2x, 8px)}.___SBaseTrigger_1rf65_gg_._size_l_1rf65_gg_ .___SAddon_1rf65_gg_:not(:only-child):last-child{margin-left:var(--intergalactic-spacing-2x, 8px)}.___SBaseTrigger_1rf65_gg_._neighborLocation_right_1rf65_gg_{border-top-right-radius:0;border-bottom-right-radius:0}.___SBaseTrigger_1rf65_gg_._neighborLocation_both_1rf65_gg_{border-radius:0;margin-left:-1px}.___SBaseTrigger_1rf65_gg_._neighborLocation_left_1rf65_gg_{border-top-left-radius:0;border-bottom-left-radius:0;margin-left:-1px}.___SText_1rf65_gg_.__display-placeholder_1rf65_gg_{color:var(--intergalactic-text-placeholder, #8a8e9b)}.___SBaseTrigger_1rf65_gg_._state_valid_1rf65_gg_{border-color:var(--intergalactic-border-success-active, #007c65)}.___SBaseTrigger_1rf65_gg_._state_invalid_1rf65_gg_{border-color:var(--intergalactic-border-critical-active, #d1002f)}.___SBaseTrigger_1rf65_gg_._state_invalid_1rf65_gg_.__keyboardFocused_1rf65_gg_{border-color:var(--intergalactic-border-critical-active, #d1002f);box-shadow:var(--intergalactic-keyboard-focus-invalid, 0px 0px 0px 3px rgba(255, 73, 83, 0.5))}.___SInvalidPattern_1rf65_gg_._size_m_1rf65_gg_{margin-left:calc(-1*var(--intergalactic-spacing-2x, 8px))}.___SInvalidPattern_1rf65_gg_._size_l_1rf65_gg_{margin-left:calc(-1*var(--intergalactic-spacing-3x, 12px))}",
    "1rf65_gg_"
  ), {
    __SBaseTrigger: "___SBaseTrigger_1rf65_gg_",
    _disabled: "__disabled_1rf65_gg_",
    __SInner: "___SInner_1rf65_gg_",
    __SText: "___SText_1rf65_gg_",
    __SAddon: "___SAddon_1rf65_gg_",
    __SBaseAddon: "___SBaseAddon_1rf65_gg_",
    _neighborLocation_right: "_neighborLocation_right_1rf65_gg_",
    _neighborLocation_both: "_neighborLocation_both_1rf65_gg_",
    _neighborLocation_left: "_neighborLocation_left_1rf65_gg_",
    "_display-placeholder": "__display-placeholder_1rf65_gg_",
    _state_valid: "_state_valid_1rf65_gg_",
    __SInvalidPattern: "___SInvalidPattern_1rf65_gg_",
    _size_m: "_size_m_1rf65_gg_",
    _size_l: "_size_l_1rf65_gg_",
    _keyboardFocused: "__keyboardFocused_1rf65_gg_",
    _active: "__active_1rf65_gg_",
    _state_invalid: "_state_invalid_1rf65_gg_"
  })
), c = /* @__PURE__ */ function(e) {
  P(r, e);
  var g = A(r);
  function r() {
    return w(this, r), g.apply(this, arguments);
  }
  return k(r, [{
    key: "getTextProps",
    value: function() {
      var _ = this.asProps, o = _.placeholder, a = _.empty;
      return {
        placeholder: o,
        empty: a
      };
    }
  }, {
    key: "render",
    value: function() {
      var _ = this.asProps, o = v, a = "span", d = E, i = this.asProps, x = i.Children, u = i.styles, b = i.theme, S = i.neighborLocation, y = i.empty, T = i.state, B = i.size;
      return R.warn(b !== void 0, "The 'theme' property is deprecated, use 'state'", this.asProps["data-ui-name"] || f.displayName), /* @__PURE__ */ t.createElement(F.Detect, {
        neighborLocation: S
      }, function(z) {
        var l;
        return l = h(u), /* @__PURE__ */ t.createElement(o, l.cn("SBaseTrigger", p({}, m({
          tag: "button",
          type: "button",
          neighborLocation: z,
          state: b
        }, _))), T === "invalid" && /* @__PURE__ */ t.createElement(d, l.cn("SInvalidPattern", {
          size: B
        })), /* @__PURE__ */ t.createElement(a, l.cn("SInner", {}), N(x, f.Text, f.Addon, y)));
      });
    }
  }]), r;
}(C);
s(c, "displayName", "BaseTrigger");
s(c, "enhance", [j(), D({
  variable: "--intergalactic-duration-control",
  fallback: "200",
  map: Number.parseInt,
  prop: "duration"
}), $({
  animateProps: ["width"],
  onChangeOf: ["value"]
})]);
s(c, "style", O);
s(c, "defaultProps", {
  size: "m",
  empty: !1
});
function V(e) {
  var g = arguments[0], r, n = v, _ = e.children, o = e.styles, a = e.empty, d = e.placeholder;
  return r = h(o), /* @__PURE__ */ t.createElement(n, r.cn("SText", p({}, m({
    "display-placeholder": a,
    "aria-hidden": a
  }, g))), a ? d : _);
}
function q(e) {
  var g = arguments[0], r, n = v, _ = e.styles;
  return r = h(_), /* @__PURE__ */ t.createElement(n, r.cn("SAddon", p({}, m({}, g))));
}
var f = L(c, {
  Text: V,
  Addon: q
});
export {
  f as default
};
